/**
 * USE-ESTABLISHMENT-NOTIFICATIONS
 * Taches calculees pour l'etablissement connecte. Le home n'en lit que le nombre, le panneau les
 * affiche et a besoin des listes concernees : les deux passent donc par ce hook, sinon le contexte
 * des notifications est reconstruit deux fois et l'un des deux oublie un type le jour d'un ajout.
 */
import { useAppSelector } from "@/core/root-reducer"
import documentStore from "@/entities/document/model/document.store"
import { getComputedNotifications } from "@/entities/notification/model/notification.utils"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import preventionActionStore from "@/entities/prevention-action/model/prevention-action.store"
import {
  groupMeasuresByRisk,
  isPreventionActionWithoutDate,
  matchesMeasuresView
} from "@/entities/prevention-action/model/prevention-action.utils"
import { hasRpsSurveyToProcess } from "@/redux/account.types"

export function useEstablishmentNotifications() {
  const documentNeedsGeneration = useAppSelector(documentStore.selectors.needsGeneration)
  const documentNotifications = useAppSelector(documentStore.selectors.outdatedNotificationTypes)
  const physicalRisks = useAppSelector(physicalRiskStore.selectors.list)
  const preventionActions = useAppSelector(preventionActionStore.selectors.list)
  const accountRisksSettings = useAppSelector((state) => state._session.accountRisksSettings)
  const rpsSurveys = useAppSelector((state) => state.account.rpsSurveys)
  //Le module RPS porte le dashboard qui exploite l'enquete : sans lui, l'import n'aurait rien a
  //afficher. Le drapeau vient du compte, il est donc renseigne aussi en interface risques.
  const isRpsModuleActive = useAppSelector((state) => state._session.modules.survey.rps)

  const preventionActionsWithoutDate = preventionActions.filter(isPreventionActionWithoutDate)
  //Meme regroupement que la vue "Mesures absentes" : un risque sans mesure y est un risque a traiter
  const measuresByRisk = groupMeasuresByRisk(preventionActions)
  const risksWithoutMeasure = physicalRisks.filter((risk) =>
    matchesMeasuresView(measuresByRisk.get(risk.id) ?? [], "missing")
  )
  const hasRpsSurveyToLink =
    !accountRisksSettings.allowMultipleEstablishments &&
    isRpsModuleActive &&
    hasRpsSurveyToProcess(rpsSurveys, accountRisksSettings.riskSurveys)

  const notifications = getComputedNotifications({
    documentNeedsGeneration,
    documentNotifications,
    preventionActionsWithoutDate: preventionActionsWithoutDate.map((action) => ({ id: action.id, name: action.name })),
    risksWithoutMeasure: risksWithoutMeasure.map((risk) => ({ id: risk.id, name: risk.cName })),
    hasRpsSurveyToLink
  })

  return { documentNotifications, notifications, preventionActionsWithoutDate, risksWithoutMeasure }
}
